(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement"]) return;
  try {
    
  if (!customElements.get('vh-announcement-ticker')) {
    customElements.define('vh-announcement-ticker', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.track = this.querySelector('.vh-ticker__track');
        this.group = this.querySelector('.vh-ticker__group');
        this.viewport = this.querySelector('.vh-ticker__viewport');
        this.toggle = this.querySelector('[data-ticker-toggle]');
        if (!this.track || !this.group || !this.viewport) return;
        this.controller = new AbortController();
        const listen = (target, type, listener, options = {}) => target?.addEventListener(type, listener, { ...options, signal:this.controller.signal });
        this.mobile = matchMedia('(max-width:749px)');
        this.reduced = matchMedia('(prefers-reduced-motion:reduce)');
        this.speed = Math.max(16, Math.min(60, Number(this.dataset.speed) || 32));
        this.paused = false;
        this.hovered = false;
        this.visible = true;
        this.generation = (this.generation || 0) + 1;
        const generation = this.generation;
        listen(this.toggle, 'click', () => { this.paused = !this.paused; if (!this.paused) this.viewport.scrollLeft = 0; this.sync(); });
        listen(this, 'pointerdown', event => { if (event.target.closest('.vh-ticker__message')) { this.paused = true; this.sync(); } });
        listen(this, 'focusin', event => {
          const item = event.target.closest('[data-announcement-index]');
          if (item) this.reveal(item);
        });
        listen(this, 'mouseenter', () => { if (matchMedia('(hover:hover)').matches) { this.hovered = true; this.sync(); } });
        listen(this, 'mouseleave', () => { this.hovered = false; this.sync(); });
        listen(this, 'shopify:block:select', event => {
          const item = event.target.closest('[data-announcement-index]');
          if (item) this.reveal(item);
        });
        listen(this.mobile, 'change', () => this.measure());
        listen(this.reduced, 'change', () => this.measure());
        listen(document, 'visibilitychange', () => this.sync());
        this.setAttribute('data-ready', '');
        this.measure();
        this.resizeObserver = new ResizeObserver(() => this.measure());
        this.resizeObserver.observe(this.viewport);
        this.resizeObserver.observe(this.group);
        if ('IntersectionObserver' in window) {
          this.intersectionObserver = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.sync(); });
          this.intersectionObserver.observe(this);
        }
        document.fonts?.ready.then(() => { if (this.isConnected && this.generation === generation) this.measure(); });
      }
      disconnectedCallback() {
        this.animation?.cancel();
        this.animation = null;
        this.resizeObserver?.disconnect();
        this.intersectionObserver?.disconnect();
        this.controller?.abort();
        this.controller = null;
        this.generation++;
      }
      measure() {
        if (!this.isConnected) return;
        if (!this.mobile.matches || this.reduced.matches) {
          this.animation?.cancel();
          this.animation = null;
          this.viewport.scrollLeft = 0;
          this.sync();
          return;
        }
        const minimum = this.viewport.clientWidth + 'px';
        if (this.style.getPropertyValue('--vh-ticker-min-width') !== minimum) this.style.setProperty('--vh-ticker-min-width', minimum);
        const distance = this.group.getBoundingClientRect().width;
        if (distance <= 0) return;
        if (this.animation && Math.abs(distance - this.distance) < .5) { this.sync(); return; }
        const progress = this.animation ? ((Number(this.animation.currentTime) || 0) % this.duration) / this.duration : 0;
        this.animation?.cancel();
        this.distance = distance;
        this.duration = distance / this.speed * 1000;
        this.viewport.scrollLeft = 0;
        this.animation = this.track.animate([{transform:'translate3d(0,0,0)'},{transform:'translate3d(-' + distance + 'px,0,0)'}],{duration:this.duration,iterations:Infinity,easing:'linear'});
        this.animation.pause();
        this.animation.currentTime = progress * this.duration;
        this.sync();
      }
      reveal(item) {
        if (!this.mobile.matches) return;
        this.paused = true;
        if (this.animation) {
          const offset = item.getBoundingClientRect().left - this.group.getBoundingClientRect().left;
          this.animation.currentTime = Math.max(0, offset) / this.speed * 1000;
          this.viewport.scrollLeft = 0;
        }
        this.sync();
      }
      sync() {
        this.toggleAttribute('data-paused', this.paused);
        if (this.animation) {
          if (this.paused || this.hovered || !this.visible || document.hidden || !this.isConnected) this.animation.pause();
          else this.animation.play();
        }
        this.toggle?.setAttribute('aria-pressed', String(this.paused));
        this.toggle?.setAttribute('aria-label', this.paused ? this.toggle.dataset.playLabel : this.toggle.dataset.pauseLabel);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        const btn = event.target.querySelector('button');
        if (btn) btn.click();
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        // Capture-phase interceptor registered before modal binds its handler.
        // On mobile, blocks the modal handler so the link navigates normally.
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          // If a holder already exists from another section (e.g. product grid),
          // remove our duplicate modal shell to avoid duplicate IDs
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('kit-shoppable-hero', KitShoppableHero);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vh-seasonal-duo-hero-2026"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('vh-seasonal-hero')) {
  customElements.define('vh-seasonal-hero', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.copies = [...this.querySelectorAll('[data-vh-copy]')];
      this.medias = [...this.querySelectorAll('[data-vh-media]')];
      if (!this.copies.length) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const listen = (target, event, listener, options = {}) => target?.addEventListener(event, listener, { ...options, signal });
      this.index = 0;
      this.request = 0;
      this.hovered = false;
      this.visible = true;
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.reduced.matches || this.dataset.designMode === 'true';
      this.toggle = this.querySelector('[data-vh-autoplay-toggle]');
      this.counter = this.querySelector('[data-vh-current]');
      this.status = this.querySelector('[data-vh-status]');
      if (this.counter) this.counter.textContent = '01';
      if (this.status) this.status.textContent = '';
      this.stage = this.querySelector('[data-vh-viewport]');
      this.autoplay = this.dataset.autoplay === 'true';
      this.delay = Number(this.dataset.delay) || 8000;
      this.copies.forEach((copy, index) => this.setActive(copy, index === 0));
      this.medias.forEach((media, index) => this.setActive(media, index === 0));
      this.dataset.slide = '0';
      this.setAttribute('data-vh-ready', '');
      listen(this.querySelector('[data-vh-prev]'), 'click', () => this.go(this.index - 1, true));
      listen(this.querySelector('[data-vh-next]'), 'click', () => this.go(this.index + 1, true));
      listen(this.toggle, 'click', () => {
        this.paused = !this.paused;
        this.updateControl();
        this.schedule();
      });
      listen(this, 'focusin', event => { if (event.target !== this.toggle) this.pause(); });
      listen(this, 'mouseenter', () => { this.hovered = true; this.clearTimer(); });
      listen(this, 'mouseleave', () => { this.hovered = false; this.schedule(); });
      listen(document, 'visibilitychange', () => this.schedule());
      listen(this.reduced, 'change', () => { if (this.reduced.matches) this.pause(); });
      listen(this, 'keydown', event => {
        if (event.target.closest('input,textarea,select,[contenteditable="true"]')) return;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          this.go(this.index + (event.key === 'ArrowLeft' ? -1 : 1), true);
        }
      });
      let start = null;
      listen(this.stage, 'touchstart', event => {
        start = event.touches.length === 1 ? { x: event.touches[0].clientX, y: event.touches[0].clientY } : null;
      }, { passive: true });
      listen(this.stage, 'touchcancel', () => { start = null; }, { passive: true });
      listen(this.stage, 'touchend', event => {
        if (!start || !event.changedTouches.length) return;
        const dx = event.changedTouches[0].clientX - start.x;
        const dy = event.changedTouches[0].clientY - start.y;
        start = null;
        if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy) * 1.5) this.go(this.index + (dx < 0 ? 1 : -1), true);
      }, { passive: true });
      listen(this, 'shopify:block:select', event => {
        const copy = event.target.closest('[data-vh-copy]');
        if (copy) this.go(Number(copy.dataset.index), true);
      });
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting && entries[0].intersectionRatio >= .25;
          this.schedule();
        }, { threshold: [0, .25] });
        this.observer.observe(this.stage);
      }
      const queueImages = () => {
        this.preloadTimer = setTimeout(() => {
          if (this.isConnected) this.medias.forEach((_, index) => { if (index) this.hydrate(index); });
        }, 1200);
      };
      const firstImage = this.medias[0]?.querySelector('img');
      if (firstImage && !firstImage.complete) listen(firstImage, 'load', queueImages, { once: true });
      else queueImages();
      this.updateControl();
      this.schedule();
    }
    disconnectedCallback() {
      this.clearTimer();
      clearTimeout(this.preloadTimer);
      this.observer?.disconnect();
      this.controller?.abort();
      this.controller = null;
      this.request++;
    }
    setActive(element, active) {
      element.classList.toggle('is-active', active);
      element.inert = !active;
    }
    hydrate(index) {
      const media = this.medias[index];
      media.querySelectorAll('[data-vh-srcset]').forEach(node => {
        node.setAttribute('srcset', node.dataset.vhSrcset);
        node.removeAttribute('data-vh-srcset');
      });
      media.querySelectorAll('[data-vh-src]').forEach(node => {
        node.setAttribute('src', node.dataset.vhSrc);
        node.removeAttribute('data-vh-src');
      });
      return media.querySelector('img');
    }
    async imageReady(index) {
      const img = this.hydrate(index);
      if (!img) return true;
      img.loading = 'eager';
      if (img.complete) return img.naturalWidth > 0;
      return new Promise(resolve => {
        const signal = this.controller.signal;
        let timeout;
        const finish = ready => {
          clearTimeout(timeout);
          img.removeEventListener('load', loaded);
          img.removeEventListener('error', failed);
          signal.removeEventListener('abort', failed);
          resolve(ready);
        };
        const loaded = () => finish(true);
        const failed = () => finish(false);
        img.addEventListener('load', loaded, { once: true });
        img.addEventListener('error', failed, { once: true });
        signal.addEventListener('abort', failed, { once: true });
        timeout = setTimeout(failed, 6000);
      });
    }
    async go(target, manual = false) {
      if (manual) this.pause();
      const next = (target + this.copies.length) % this.copies.length;
      if (next === this.index) return;
      const request = ++this.request;
      const ready = await this.imageReady(next);
      if (!this.isConnected || request !== this.request) return;
      if (!ready) { this.pause(); return; }
      if (this.copies[this.index].contains(document.activeElement)) {
        this.querySelector('[data-vh-next]')?.focus({ preventScroll: true });
      }
      this.copies.forEach((copy, index) => this.setActive(copy, index === next));
      this.medias.forEach((media, index) => this.setActive(media, index === next));
      this.index = next;
      this.dataset.slide = String(next);
      if (this.counter) this.counter.textContent = String(next + 1).padStart(2, '0');
      if (manual && this.status) this.status.textContent = this.dataset.statusTemplate.replace('[current]', String(next + 1));
      this.schedule();
    }
    pause() { this.paused = true; this.clearTimer(); this.updateControl(); }
    clearTimer() { clearTimeout(this.timer); this.timer = null; }
    updateControl() {
      if (!this.toggle) return;
      this.toggle.classList.toggle('is-paused', this.paused);
      this.toggle.setAttribute('aria-pressed', String(this.paused));
      this.toggle.setAttribute('aria-label', this.paused ? this.dataset.playLabel : this.dataset.pauseLabel);
    }
    schedule() {
      this.clearTimer();
      if (!this.autoplay || this.paused || this.hovered || !this.visible || document.hidden || this.copies.length < 2 || !this.isConnected) return;
      this.timer = setTimeout(() => this.go(this.index + 1), this.delay);
    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
